<template>
  <div>
    <div class="cl">
      <div class="home-card fl" style="width:400px;margin-right:10px">
        <div class="title">
          <span class="name">我的信息</span>
        </div>
        <div class="flex-s-s pad10">
          <img class="photo" :src="userMess.photo?userMess.photo:defaultPhoto" />
          <div style="width:210px">
            <div class="flex-sb-c mat20">
              <span class="name">{{userMess.userName}}</span>
              <div class="type flex-s-c">
                <!-- <i class="iconfont icon-ktv"></i> -->
                <span v-show="userMess.applyPost==1">讲解</span>
                <span v-show="userMess.applyPost==2">服务</span>
                <span v-show="userMess.applyPost==3">策划</span>
              </div>
            </div>
            <div class="kind">
              <span class="icon"> <i class="iconfont icon-persion"></i></span>
              <span v-if="userMess.status==3">正式</span>
              <span v-if="userMess.status==2">试用</span>
            </div>
            <div class="number" v-if="userMess.status==3">{{userMess.volunteerNumber}}</div>
            <div class="number" style="cursor: pointer;" v-if="userMess.status==2" @click="showRule">查看试用期要求</div>
          </div>
        </div>
      </div>
      <div class="home-card fl" style="width:calc(100% - 420px)">
        <div class="title">
          <span class="name">我的数据</span>
        </div>
        <div class="flex-s-s pad10 data">
          <div class="item" v-for="item in myDataList" :style="{background: item.bg,borderColor:item.border}">
            <div class="value" :style="{color:item.color}">{{item.taskFieldValue}}</div>
            <div class="key">{{item.taskFieldKey}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="home-card mat10" style="width:calc(100% - 10px)">
      <div class="title">
        <span class="name">我的日程</span>
        <span class="more" @click="$router.push({name:'mySchedule'})">查看&nbsp;></span>
      </div>
      <div class="cl">
        <ul class="schedule">
          <li v-for="item in scheduleList">
            <div>{{item.date|mdFilter}}</div>
            <div>{{item.date|weekdayFilter}}</div>
            <div class="none" v-if="item.myScheduleList.length==0">无</div>
            <template v-for="(cItem,cIndex) in item.myScheduleList" v-if="cIndex<2">
              <div class="activity blue" :class="[cItem.activityType==1?'blue':cItem.activityType==2?'orange':cItem.activityType==3?'green':cItem.activityType==4?'blue2':'']">
                <span style="margin-right:10px">{{cItem.startTime}}</span>
                <span v-if="cItem.activityType==1">讲解</span>
                <span v-if="cItem.activityType==2">服务</span>
                <span v-if="cItem.activityType==3">策划</span>
                <span v-if="cItem.activityType==4">其他活动</span>
              </div>

              <!-- <div class="activity orange"><span style="margin-right:10px">09:00</span><span>服务</span></div>
            <div class="activity green"><span style="margin-right:10px">09:00</span><span>策划</span></div>
            <div class="activity blue2"><span style="margin-right:10px">09:00</span><span>其他活动</span></div> -->
            </template>
            <div class="activity gray" v-if="item.myScheduleList.length>2" @click="scheduleMore(item)">
              <span style="margin-right:10px"></span>
              <span>更多</span>
            </div>

            <div class="eat" v-if="item.mealStatus==1">就餐</div>
          </li>
          <!-- <li>
            <div>7月14日</div>
            <div>星期二</div>
            <div class="none">无</div>
          </li> -->

        </ul>
      </div>
    </div>
    <el-row>
      <el-col :span="12">
        <div class="home-card fl mat10" style="margin-right:10px;height:256px;width:calc(100% - 10px)">
          <div class="title">
            <span class="name">我的消息</span>
            <span class="more" @click="$router.push({name:'news'})">查看&nbsp;></span>
          </div>
          <div class="list1">
            <template v-if="newsList.length==0">
              <div class="no-data sm">
                <img src="@images/none.png" />
                <div>暂无数据</div>
              </div>
            </template>
            <template v-else>
              <div class="flex-sb-c item" v-for="item in newsList" @click="$router.push({name:'newsDetail',params:{id:item.id}})">
                <span class="unread" v-if="item.isRead==0"></span>
                <span :title="item.content" class="list1-title" v-html="item.content"></span>
                <span class="fontcolor-grey ">{{item.sendTime}}</span>
              </div>
            </template>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="home-card fl mat10" style="margin-right:10px;width:calc(100% - 10px);height: 256px;">
          <div class="title">
            <span class="name">规章条例</span>
            <span class="more" @click="$router.push({name:'rules'})">查看&nbsp;></span>
          </div>
          <div class="list1">
            <template v-if="newsList.length==0">
              <div class="no-data sm">
                <img src="@images/none.png" />
                <div>暂无数据</div>
              </div>
            </template>
            <template v-else>
              <div class="flex-s-c item" v-for="item in ruleList" @click="$router.push({name:'rulesDetail',params:{id:item.id}})">
                <!-- <i class="iconfont icon-yijin-shishixize"></i> -->
                <!-- <span>> {{item.title}}</span> -->
                <span :title="item.title" class="list1-title">> {{item.title}}</span>
              </div>
            </template>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import { getWeekStartDate, getWeekEndDate, formatDate } from '@/libs/utils'
export default {
  name: "Home",
  components: {
    // HelloWorld
  },
  data() {
    return {
      ruleList: [],
      newsList: [],
      myDataList: [],
      scheduleList: [],
      colorList: [
        { bg: '#FFF3E3', color: '#E7650E', border: '#FCDFBC' },
        { bg: '#EAF4FF', color: '#4E97ED', border: '#C5DEFA' },
        { bg: '#EAFFFB', color: '#1CC3A1', border: '#C1F1E7' },
        { bg: '#F1FFE3', color: '#67A920', border: '#D3EEB5' },
        { bg: '#FFF2F0', color: '#E25A36', border: '#FFD7CD' }],
      defaultPhoto: require('@images/photo-noneF.jpg')
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user.user
    },
  },
  watch: {},
  methods: {
    getRuleList() {
      let params = {
        pageNumber: 1,
        pageSize: 3
      }
      this.$api.ruleList(params).then(res => {
        this.ruleList = res.data
      })
    },
    getNewsList() {
      // console.log(this.userMess)
      // console.log(this.$store.state.user.user)
      // console.log(localStorage.getItem('userObj'))
      let params = {
        pageNumber: 1,
        pageSize: 5,
        volunteerId: this.$cookies.get('sso_userId')
      }
      this.$api.messageList(params).then(res => {
        // console.log(res)
        this.newsList = res.data.rows
      })
    },
    getMyData() {
      this.$api.getMyData({ volunteerId: this.$cookies.get('sso_userId') }).then(res => {
        this.myDataList = res.data.map((item, index) => {

          let color = this.colorList[index]
          return { ...item, ...color }
        })
        // console.log(this.myDataList)
        // console.log(res)
      })
    },
    //查看试用期要求
    showRule() {
      this.$api.getRegularRules({ volunteerId: this.$cookies.get('sso_userId') }).then(res => {
        // console.log(res.data)
        let str = "<div class='flex-c-c'><div>";
        res.data.map(item => {
          str += '<div class="key-value"><span class="key">' + item.taskFieldKey + '：' + '</span><span class="value"> ' + item.taskFieldValue + '</span></div>'
        })
        str += "</div></div>"

        this.$tips({
          title: "试用期要求",
          content: str,
          confirm: true,
          // cancel: true,
          dialogVisible: true,
          btn: {
            confirmVal: "确定",
            // cancelVal: "取消"
          }
        }).then((res) => {
          // console.log("yes", res);
          //点击确定之后的处理
        }).catch((err) => {
          // console.log("no", err);
        });
      })

    },
    getScheduleList() {
      let params = {
        startTime: getWeekStartDate(new Date(), 3),
        endTime: getWeekEndDate(new Date(), 3),
        volunteerId: this.$cookies.get('sso_userId')
      }
      this.$api.getMySchedule(params).then(res => {
        this.scheduleList = res.data
        // console.log(res.data)
      })
    },
    scheduleMore(val) {
      // console.log(val)
      let content = "<div class='flex-c-c'><div>"
      val.myScheduleList.map(item => {
        let type

        if (item.activityType == 1) type = "讲解"
        else if (item.activityType == 2) type = "服务"
        else if (item.activityType == 3) type = "策划"
        else if (item.activityType == 4) type = "其他活动"
        content += '<div class="schedule"><span class="time">' + item.startTime + '</span><span class="title"> ' + type + '</span></div>'
      })
      content += "</div></div>"
      // console.log(content)
      this.$confirm({
        title: "我的日程",
        head: formatDate(val.data, 2) + ' ' + "星期" + formatDate(val.data, 4),
        content: content,
        confirm: true,
        dialogVisible: true,
        btn: {
          confirmVal: "确定",
        }
      }).then((res) => {

        //点击确定之后的处理
      }).catch((err) => {
        // console.log("no", err);
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getRuleList()
    this.getNewsList()
    this.getMyData()
    this.getScheduleList()
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
  filters: {
    mdFilter: (date) => {
      let now = date ? new Date(date) : new Date()
      let mymonth = (now.getMonth() + 1).toString().padStart(2, "0")
      let myday = now.getDate().toString().padStart(2, "0")
      let res = mymonth + "月" + myday + "日"
      return res
    },
    weekdayFilter: (date) => {
      let now = date ? new Date(date) : new Date()
      let week = ["日", "一", "二", "三", "四", "五", "六"]
      let myweekday = week[now.getDay()]
      let res = "星期" + myweekday
      return res
    }
  }
};
</script>
<style lang="less" scoped>
@import "./home.less";
</style>

